namespace TabAurous.OMS {
    export interface AccountGroupForm {
        AccountGroupName: Serenity.StringEditor;
        GroupUnder: Serenity.LookupEditor;
        Nature: AccountGroupEditor;
        IsDefault: Serenity.BooleanEditor;
        AffectGrossProfit: Serenity.BooleanEditor;
        Narration: Serenity.StringEditor;
    }

    export class AccountGroupForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.AccountGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountGroupForm.init)  {
                AccountGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = AccountGroupEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(AccountGroupForm, [
                    'AccountGroupName', w0,
                    'GroupUnder', w1,
                    'Nature', w2,
                    'IsDefault', w3,
                    'AffectGrossProfit', w3,
                    'Narration', w0
                ]);
            }
        }
    }
}
